import{startCase as s}from"lodash";const n=r=>{const e=[];for(const[o,t]of Object.entries(r))t&&e.push({label:s(o),value:Number(t)?Number(t).toFixed(1):t.toString()});return e};export{n as getStars};
